import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import VtxBaseModal from '../vtx-base-modal';
import BaseContent from './base';
import './style';
const TABS_BASE = 'construction-site-base';

const VtxConstructionSiteModal = forwardRef(props => {
    const { id, title, width, subTitle, visible, onCancel } = props;
    return (
        <VtxBaseModal
            title={title}
            subTitle={subTitle}
            width={width}
            visible={visible}
            onCancel={onCancel}
            tabs={[{ key: TABS_BASE, value: '基础信息' }]}
            contents={[{ key: TABS_BASE, content: <BaseContent id={id} /> }]}
        />
    );
});

VtxConstructionSiteModal.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    width: PropTypes.number,
    subTitle: PropTypes.string,
    visible: PropTypes.bool,
    onCancel: PropTypes.func,
};
export default VtxConstructionSiteModal;
